import { SUPPORTED_BRAND_KEYS } from "../../../constants/brandConstants";

const BRAND_OVERRIDE_STORAGE_KEY = "brandOverride";
const ALLOWED_BRAND_OVERRIDE_KEYS = new Set<string>(SUPPORTED_BRAND_KEYS);

export const getSessionBrandOverride = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const value = String(window.sessionStorage.getItem(BRAND_OVERRIDE_STORAGE_KEY) || "").trim().toLowerCase();
  return ALLOWED_BRAND_OVERRIDE_KEYS.has(value) ? value : "";
};

export const getCognitoBrandClientMetadata = () => ({
  host: typeof window !== "undefined" ? window.location.host : "",
  brandOverride: getSessionBrandOverride(),
});
